export function GET_PRODUCTS_REQUEST(state) {
  state;
  state.products = {
    ...state.products,
    isLoading: true
  };
}
export function GET_PRODUCTS_SUCCESS(state, payload) {
  let data = [];
  payload.results.data.map(item => {
    data.push({
      oracleItemId: item.oracleItemId || "-",
      oracleItemCode: item.oracleItemCode || "-",
      itemName: item.itemName || "-",
      description: item.description || "-",
      itemType: item.itemType || "-",
      itemCode: item.itemCode || "-",
      isActive: item.isActive
    });
    return item;
  });
  state;
  state.products = {
    ...state.products,
    isLoading: false,
    data: data,
    totalPage: payload.results.totalPage,
    count: payload.results.count
  };
}
export function GET_PRODUCTS_ERROR(state, payload) {
  state;
  state.products = {
    ...state.products,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function GET_PRODUCT_REQUEST(state) {
  state;
  state.product = {
    ...state.product,
    isLoading: true
  };
}
const fieldProduct = ["branchCode", "customerType", "customerClassCode"];
export function GET_PRODUCT_SUCCESS(state, payload) {
  const { item } = payload.results.data.data;
  let data = {};
  if (item) {
    item.priceDetails.rows.map(item => {
      if (item.itemPrice == null) {
        item.itemPrice = "-";
      }
      fieldProduct.map(field => {
        if (item.price[field] == null) {
          item.price[field] = "-";
        }
      });
      return item;
    });
  }
  data = item;
  let principalId = "";
  if (item.brand) {
    if (item.brand.principal) {
      if (item.brand.principal.principalId) {
        principalId = item.brand.principal.principalId;
      }
    }
  }
  data.principalId = principalId;
  state;
  state.product = {
    ...state.product,
    isLoading: false,
    data: data || {}
  };
}
export function GET_PRODUCT_ERROR(state, payload) {
  state;
  state.product = {
    ...state.product,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_PRODUCT_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_PRODUCT_SUCCESS(state, payload) {
  state;
  state.products = [...state.products, payload.results.data];
  state.isLoading = false;
}
export function CREATE_PRODUCT_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function EDIT_PRODUCT_REQUEST(state) {
  state;
  state.product = {
    ...state.product,
    isLoading: true
  };
}
export function EDIT_PRODUCT_SUCCESS(state) {
  state;
  state.products = {
    ...state.products,
    isLoading: false
  };
}
export function EDIT_PRODUCT_ERROR(state, payload) {
  state;
  state.product = {
    ...state.product,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function DELETE_PRODUCT_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_PRODUCT_SUCCESS(state, payload) {
  let index = state.products.findIndex(item => item.id == payload.id);
  state.products.splice(index, 1);
  state;
  state.products;
  state.isLoading = false;
}
export function DELETE_PRODUCT_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
